export const platformVersion = '^15.4.0';
